import { BCLabel } from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import React, { JSX } from 'react';
import { CovertFontToCSS, ICSSProperties } from '../../../../entities/common';
import LabelBase from '../../base/LabelBase';
import { IFormMetadataProperties } from './entities/IFormMetadataProperties';

export default class FormMetadata extends LabelBase {
	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.FormMetadata;
	}

	__loadProperties(data: IFormMetadataProperties) {
		super.__loadProperties(data);
	}

	private getStyles(): ICSSProperties {
		return CovertFontToCSS(this.font);
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData()
		};
	}

	__render(children?: JSX.Element) {
		const style: React.CSSProperties = {
			...this.getStyles(),
			...this.style,
			height: this.height,
			lineHeight: this.lineHeight
		};

		return super.__render(
			<BCLabel
				customStyles={style}
				title={this.title.getText()}
			>
				{this.text.getText()}
			</BCLabel>
		);
	}
}
